import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import { shouldShow, truncateText } from "@zenith/utils/TransactionDisplayHelpers";

export interface QrCodeTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const QrCodeTransactionDetails = memo(function QrCodeTransactionDetails(
  props: QrCodeTransactionDetailsProps
) {
  const { transaction } = props;

  return (
    <>
      {shouldShow(transaction?.beneficiaryName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Name</p>
          <p className="font-medium text-neutral-900">
            {transaction?.beneficiaryName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.bankName) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Payer's Bank</p>
          <p className="font-medium text-neutral-900">
            {transaction?.bankName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.description) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-3/5 text-right">
            <p className="font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default QrCodeTransactionDetails;